import React from "react";
import { Link } from "react-router-dom";
import { T } from "../../app/tokens.js";
import { log } from "../../utils/logger.js";
import { useDataReconciliationSummary } from "../../hooks/useDataReconciliationSummary.js";

export const DATA_RECONCILIATION_PATH = "/admin?section=data&tab=reconciliation";

export function ReconciliationFindingAlert({ currentRole }) {
  const { summary, acknowledge } = useDataReconciliationSummary(currentRole);
  if (
    currentRole !== "admin" ||
    !summary ||
    summary.activeCount < 1 ||
    summary.unacknowledgedCount < 1
  ) return null;

  const dismiss = () => {
    void Promise.resolve(acknowledge(summary.findingVersion)).catch((err) => {
      log.warn("Reconciliation alert acknowledgement failed", { err: String(err) });
    });
  };

  return (
    <section
      data-testid="reconciliation-finding-alert"
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginBottom: 16,
        padding: "12px 14px",
        border: `1px solid ${T.border}`,
        borderRadius: 10,
        background: T.redSoft,
        color: "var(--v2-dark)",
      }}
    >
      <span aria-hidden="true" style={{ color: T.red, fontWeight: T.fwBold }}>!</span>
      <div style={{ flex: 1 }}>
        <strong>{summary.activeCount} active data reconciliation {summary.activeCount === 1 ? "finding" : "findings"}</strong>
        <span> need administrator review. </span>
        <Link
          to={DATA_RECONCILIATION_PATH}
          data-testid="reconciliation-finding-link"
          style={{ color: "var(--v2-accent)", fontWeight: T.fwSemibold }}
        >
          Review findings
        </Link>
      </div>
      <button
        type="button"
        data-testid="dismiss-reconciliation-finding-alert"
        aria-label="Dismiss reconciliation findings alert"
        onClick={dismiss}
        style={{
          border: 0,
          borderRadius: 6,
          padding: "5px 8px",
          background: "transparent",
          color: "var(--v2-mid)",
          cursor: "pointer",
          fontSize: T.fsBase,
        }}
      >
        Dismiss
      </button>
    </section>
  );
}